import React from 'react';
import LocationTemplate from './LocationTemplate';

const WarsawPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Warsaw"
      stateName="North Carolina"
      countyName="Duplin"
      zipCodes={["28398"]}
      latitude={34.9996}
      longitude={-78.0947}
      population={3054}
      historicalFact="Originally called Duplin Depot, renamed in 1855 in solidarity with Poland's struggle for independence."
      nearbyTowns={[
        "Clinton, NC",
        "Rose Hill, NC",
        "Mount Olive, NC",
        "Faison, NC",
        "Beulaville, NC",
        "Turkey, NC",
        "Calypso, NC",
        "Wallace, NC"
      ]}
    />
  );
};

export default WarsawPage;